export const getMonth = (date: Date): number => new Date(date).getMonth();
